import {
  IDmMucThuNienCheCopyRequest,
  IDmMucThuNienCheViewModelRequest,
  IMucThuNienCheApDungRequest,
  IMucThuNienChePreviewRequest,
} from "../../model/request/category/dmMucThuNienCheRequest";
import { IDmMucThuNienChe } from "../../model/respone/category/IDmMucThuNienChe";
import { apiClient } from "../apiClient";

export const MUC_THU_NIEN_CHE_ENDPOINT = "muc-thu-nien-che";

export const mucThuNienCheApi = {
  Select: (payload: IDmMucThuNienCheViewModelRequest) =>
    apiClient.post(`${MUC_THU_NIEN_CHE_ENDPOINT}/select-data`, payload),

  Save: (payload: IDmMucThuNienChe[]) =>
    apiClient.post(`${MUC_THU_NIEN_CHE_ENDPOINT}/save-data`, payload),

  Lock: (payload: IDmMucThuNienCheViewModelRequest) =>
    apiClient.post(`${MUC_THU_NIEN_CHE_ENDPOINT}/true/lock-or-unlock`, payload),

  Unlock: (payload: IDmMucThuNienCheViewModelRequest) =>
    apiClient.post(`${MUC_THU_NIEN_CHE_ENDPOINT}/false/lock-or-unlock`, payload),

  Copy: (payload: IDmMucThuNienCheCopyRequest) =>
    apiClient.post(`${MUC_THU_NIEN_CHE_ENDPOINT}/copy`, payload),

  /** Xem trước sinh viên sẽ nhận mức thu (để cảnh báo em đã có khoản từ trước). */
  PreviewApDung: (payload: IMucThuNienChePreviewRequest) =>
    apiClient.post(`${MUC_THU_NIEN_CHE_ENDPOINT}/preview-ap-dung`, payload),

  ApDung: (payload: IMucThuNienCheApDungRequest) =>
    apiClient.post(`${MUC_THU_NIEN_CHE_ENDPOINT}/ap-dung`, payload),
};
